__webpack_require__.p = "https://baomoi-static.bmcdn.me/wap-v2/prod/v0.11.24/_next/";